<template>
  <div style="height: 100%;">
    <!-- 年度开工率 -->
    <Echart :options="options" id="bottomLeftChart" height="100%" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from './echart/bar'
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          title: {
            text: newData.title,
            textStyle: {
              color: "#fff"
            }
          },
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#7B7DDC"
              }
            }
          },
          // legend: {
          //   data: ["计划贯通"],
          //   textStyle: {
          //     color: "#B4B4B4"
          //   },
          //   top: "0%",
          //   left:"0%",
          // },


          grid: {
            // x: "0%",
            // width: "88%",
            // y: "4%",
            // top:"5%",
            // left: '2%',
            // right: '2%',
            // bottom: '10%',
            left: '3%',
            right: '4%',
            bottom: '4%',
            containLabel: true,
            //  show:'true',
            borderWidth: '0'
          },
          xAxis: {
            type: "category",
            data: newData.category,
            axisLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            axisLabel: {
              formatter: "{value} "
            },
            name: newData.yAxisUnit,
          },
          series: [
            {

              type: "bar",
              barGap: "-100%",
              barWidth: "50%",
              itemStyle: {
                normal: {
                  barBorderRadius: 5,
                  color: this.createColorCode('#'+Math.floor(Math.random()*16777215).toString(16))
                }
              },
              z: -12,
              data: newData.lineData,
              label: {
                show: true,
                position: 'top',
                color: "#ffffff",
              },
            }
          ]
        }
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
//生成不同的颜色代码
 createColorCode(code){
  let colorArr=[]
	if($.inArray(code, colorArr)==-1 && code.length>6){
		colorArr[0]=code;
	}else{
		code='#'+Math.floor(Math.random()*16777215).toString(16);
		this.createColorCode(code,colorArr);
	}

	return (colorArr && colorArr.length>0) ?colorArr[0].split(','):"#fff";
}
  }
}
</script>